// extracted by mini-css-extract-plugin
module.exports = {"investors":"SpeakerCards_investors__1FIAj","btn":"SpeakerCards_btn__2iMwn","card":"SpeakerCards_card__3rdKY"};